<template>
  <div>
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div>
              <span>操作人</span>
              <el-input
                v-model="doctor_name"
                placeholder="请输入"
                style="width:140px;margin:0 10px 0 5px"
                @input="search"
                clearable
              ></el-input>
              <span>操作说明</span>
              <el-input
                v-model="title"
                placeholder="请输入"
                style="width:140px;margin:0 10px 0 5px"
                @input="search"
                clearable
              ></el-input>

              <span>操作时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width:225px;margin:0 12px"
                @change="search"
              ></el-date-picker>

              <el-button
                size="mini"
                type="info"
                style="background-color:#eceff2;;color:#747981;"
                @click="search"
              >查询</el-button>

              <span style="margin:0 10px 0 20px">状态</span>
              <el-radio-group
                v-model="status"
                @change="search"
              >
                <el-radio :label="0 ">全部</el-radio>
                <el-radio :label="1">成功</el-radio>
                <el-radio :label="2">失败</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6;">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%;min-width:1000px;"
              :header-cell-style="{background:'#F5F5F5'}"
            >
              <el-table-column
                label="操作请求时间"
                prop="create_time"
              ></el-table-column>
              <el-table-column
                label="操作人"
                prop="doctor_name"
              ></el-table-column>
              <el-table-column
                label="操作说明"
                prop="title"
              ></el-table-column>
              <el-table-column label="操作状态">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.api_data"
                    placement="top"
                  >
                    <span v-if="scope.row.is_success">
                      <i
                        class="el-icon-success"
                        style="color:#669961"
                      ></i>
                    </span>
                    <span v-else>
                      <i
                        class="el-icon-error"
                        style="color:#f24e33"
                      ></i>
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column
                label="操作人ip地址"
                prop="doctor_ip"
              ></el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hospital from '../../../api/hospital';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      date: [dayjs().subtract(3, 'month').format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')],
      title: '',
      status: 0
    };
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        title: this.title,
        status: this.status
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      hospital.getDoctorLogList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    search(value) {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>